import { OBJECT_AS_STRING } from './constants';

var isBoolean = b => typeof b === 'boolean';

var isFunction = f => typeof f === 'function';

var isNumber = n => typeof n === 'number' && !isNaN(n);

var isObject = o => OBJECT_AS_STRING.test(Object.prototype.toString.call(o));

var isString = s => typeof s === 'string';

var strictIsFinite = n => isNumber(n) && isFinite(n);

var assertType = (assertion, errorMsg) => {
  if (!assertion) {
    throw new TypeError(errorMsg);
  }
};

var assertArray = function assertArray() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  assertType(args.every(Array.isArray), 'Expected an array');
};

var assertFunction = function assertFunction() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  assertType(args.every(isFunction), 'Expected a function');
};

var assertNumber = function assertNumber() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  assertType(args.every(isNumber), 'Expected a number');
};

var assertObject = function assertObject() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  assertType(args.every(isObject), 'Expected an object');
};

var assertString = function assertString() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  assertType(args.every(isString), 'Expected a string');
};

export { assertArray, assertFunction, assertNumber, assertObject, assertString, assertType, isBoolean, isFunction, isNumber, isObject, isString, strictIsFinite };